import type { execFileSync } from 'node:child_process';

export type DetectionSource =
  | 'env'
  | 'parent'
  | 'shell'
  | 'process_title'
  | 'none'
  | 'unknown';

export type ColorLevel = 0 | 1 | 2 | 3;

export type ExecFileSync = typeof execFileSync;

export interface DetectOptions {
  /** When true, prefer outermost terminal (GUI app) over multiplexers like tmux/screen */
  preferOuter?: boolean;
  /** When true, inspect parent processes if env-based detection is missing or ambiguous */
  resolveAmbiguousFromParent?: boolean;
  /** When true, continue env-based detection even when stdout is not currently a TTY */
  unpipe?: boolean;
  env?: NodeJS.ProcessEnv;
  stdout?: Pick<NodeJS.WriteStream, 'isTTY'>;
  platform?: NodeJS.Platform;
  pid?: number;
  processTitle?: string;
  execFileSync?: ExecFileSync;
}

export interface TerminalDetails {
  terminal: string;
  source: DetectionSource;
  isTTY: boolean;
  isSSH: boolean;
  isAmbiguous: boolean;
  supportsColor: boolean;
  colorLevel: ColorLevel;
  supports256Color: boolean;
  supportsTrueColor: boolean;
  term?: string;
  termProgram?: string;
  colorTerm?: string;
  generic: string;
  appName?: string;
  pid?: number;
}

export interface ParentProcessInfo {
  pid: number;
  appName: string;
}

export interface ParentTerminalInfo extends ParentProcessInfo {
  terminal: string;
}

export interface DetectionResult {
  terminal: string;
  source: DetectionSource;
  generic?: string;
  appName?: string;
  pid?: number;
}
